import React, { useState, useEffect, useContext } from "react";
import { Row, Col, Card, Table, Form, Button, Alert, ProgressBar, Modal, Label } from "react-bootstrap";
import _ from "lodash";
import axios from "axios";
import moment from "moment";
import Utils from "./../../common/Utils";
import DateTimePicker from "react-datetime-picker";
import { UserContext } from "../../common";
import ChoosePlans from "../../components/application/ChoosePlans";

import EvidenceList from "./EvidenceList";

const Evidences = (props) => {
  const initFilter = () => ({
    pp: Utils.perpage,
    user: 0,
    branch: 0,
    type: "jobs-recent",
    fromDt: moment().startOf("year").toDate(),
    toDt: moment().toDate(),
    txt: "",
  });

  const {userData} = useContext(UserContext);

  const [filter, setFilter] = useState(initFilter());
  const [data, setData] = useState({
    loading: false,
    total: 0,
    start: 0,
    records: [],
  });
  const [showEvidences, setShowEvidences] = useState({});

  const getRecordStart = (idx = 0) => {
    return data.start + parseInt(idx) + 1;
  };

  let stout = null;

  const setSearchTxt = (e) => {
    let txt = e.currentTarget.value;
    if (stout != null) {
      window.clearTimeout(stout);
    }
    stout = window.setTimeout(() => {
      setFilter({ ...filter, st: 0, txt: txt });
    }, 1000);
  };

  const addFilters = (start) => {
    let str = [
      `pp=${filter.pp}`,
      `st=${start}`,
      `user=${filter.user}`,
      `branch=${filter.branch}`,
      `fromDt=${moment(filter.fromDt).format().substring(0, 19)}`, //== to keep the timezone out
      `toDt=${moment(filter.toDt).endOf("day").format().substring(0, 19)}`, //== to keep the timezone out
      `txt=${filter.txt}`,
    ];
    return "?" + str.join("&");
  };

  const fetchData = (start = 0) => {
    if (moment(filter.fromDt).isAfter(moment(filter.toDt))) {
      window.alert("Please select dates correctly, TO date cannot be earlier than FROM date.");
      return;
    }
    let url = Utils.apiUrl((filter.type === "tasks" ? "tasks" : "jobs") + "/fetchevidences") + addFilters(start);
    url += filter.type !== "tasks" && filter.type === "jobs-recent" ? "&type=recent" : "&type=archived";
    setData({ ...data, loading: true });
    axios
      .get(url, Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setData({
            ...data,
            loading: false,
            start: start,
            total: _.get(res, "data.total", 0),
            records: res.data.evidences,
          });
        } else {
          setData({ ...data, total: 0, start: 0, records: [], loading: false });
        }
      })
      .catch((err) => {
        setData({ ...data, loading: false });
        console.log(err);
      });
  };

  useEffect(fetchData, [filter]);

  const [teamMembers, setTeamMembers] = useState([]);

  const fetchTeamMembers = () => {
    axios
      .get(Utils.apiUrl("tasks/fetchteammembers"), Utils.apiHeaders())
      .then((res) => {
        if (res.data.success) {
          setTeamMembers(_.get(res, "data.users", []));
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };
  useEffect(fetchTeamMembers, []);

  const showPagination = ({ loading, start, total }) => {
    if (loading || (start === 0 && start + filter.pp >= total)) {
      return <></>;
    } else {
      return (
        <div className="d-flex flex-row-reverse">
          {start + filter.pp >= total && (
            <div className="text-disabled ms-2">
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right-d.png`} alt="Next" /> Next
            </div>
          )}
          {start + filter.pp < total && (
            <div className="clickable ms-2 text-clickable" onClick={() => fetchData(start + filter.pp)}>
              <img src={`${process.env.PUBLIC_URL}/images/arrow-right.png`} alt="Next" /> Next
            </div>
          )}
          {start >= filter.pp && (
            <div className="clickable text-clickable" onClick={() => fetchData(start - filter.pp)}>
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left.png`} alt="Previous" />
            </div>
          )}
          {start === 0 && (
            <div className="text-disabled">
              Previous <img src={`${process.env.PUBLIC_URL}/images/arrow-left-d.png`} alt="Previous" />
            </div>
          )}
        </div>
      );
    }
  };

  let nameChanged = null;
  const setName = (e) => {
    let name = e.currentTarget.value;
    if (nameChanged) window.clearTimeout(nameChanged);
    nameChanged = window.setTimeout(() => {
      setFilter({ ...filter, name: name });
    }, 1000);
  };

  const pageSelect = () => {
    return (
      <select
        className="form-select float-right ms-3"
        style={{ width: "80px" }}
        onChange={(e) => setFilter({ ...filter, pp: parseInt(e.target.value) })}
      >
        {[5, 10, 25, 50, 100].map((p) => (
          <option value={p} selected={filter.pp === p}>
            {p}
          </option>
        ))}
      </select>
    );
  };

  if (!Utils.hasAccess(7)) {
    return (
      <>
        {!userData.is_super_user && <h1 className="alert alert-danger p-5 mt-5">No access!</h1>}
        {userData.is_super_user && <>
            <h1 className="alert alert-danger p-4 mt-4">You current plan is restricted to use this module, please Upgrade!</h1>
            <ChoosePlans onPayment={() => { window.location.reload(); }} />
        </>}
      </>
    );
  }

  return (
    <React.Fragment>
      <div>
        <Row className="mt-4">
          <Col>
            <div className="d-flex">
              <h3 className="mx-2 my-3 title">Evidences</h3>

              <select
                className="select-control from-control-select shadow-cst filters my-auto py-2"
                style={{ height: "fit-content" }}
                value={filter.type}
                onChange={(e) => {
                  setFilter({
                    ...filter,
                    type: e.currentTarget.value,
                  });
                  setData({ ...data, records: [] });
                }}
              >
                <option value="jobs-recent">for Jobs (Recent)</option>
                <option value="jobs-archived">for Jobs(Archived)</option>
                <option value="tasks">for Tasks</option>
              </select>
            </div>
            <Form>
              <Row className="gx-1">
                <Col sm={11}>
                  <Row className="gx-0">
                    {_.get(userData,'is_super_user',false) && <Col>
                      <select
                        className="w-100 select-control form-control-select form-select shadow-cst filters"
                        value={filter.branch}
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            user: 0,
                            branch: e.currentTarget.value,
                          })
                        }
                      >
                        <option value="0">All Branches</option>
                        {_.uniqBy(_.map(teamMembers,t => _.pick(t,['branch_id','branch'])),'branch_id').map(b => <option key={b.branch_id} value={b.branch_id}>{b.branch}</option>)}
                      </select>
                    </Col>}
                    <Col className="px-1">
                      <select
                        className="w-100 select-control form-control-select form-select shadow-cst filters"
                        value={filter.user}
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            user: e.currentTarget.value,
                          })
                        }
                      >
                        <option value="0">From Everyone</option>
                        {(filter.branch === 0 ? teamMembers : _.filter(teamMembers, t => t.branch_id===filter.branch)).map((tm) => (
                          <option key={tm.id} value={tm.id}>
                            {tm.title} {tm.name}
                          </option>
                        ))}
                      </select>
                    </Col>
                    <Col className="p-0">
                      <Row className="me-md-0  pe-md-0 ms-1 bg-white h-100">
                        <Col md={6} sm={12} className="text-end align-middle py-2">
                          From : &nbsp;
                          <DateTimePicker
                            dayPlaceholder="dd"
                            monthPlaceholder="mm"
                            yearPlaceholder="yyyy"
                            clearIcon={null}
                            format="y-MM-dd"
                            onChange={(v) => setFilter({ ...filter, fromDt: v })}
                            value={filter.fromDt}
                          />
                        </Col>
                        <Col md={6} sm={12} className="text-end text-md-start align-middle py-2">
                          To : &nbsp;
                          <DateTimePicker
                            dayPlaceholder="dd"
                            monthPlaceholder="mm"
                            yearPlaceholder="yyyy"
                            clearIcon={null}
                            format="y-MM-dd"
                            onChange={(v) => setFilter({ ...filter, toDt: v })}
                            value={!_.isNull(filter.toDt) ? filter.toDt : filter.fromDt}
                          />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="gx-0">
                    <Col sm={12}>
                      <input
                        type="text"
                        className="form-control form-control-select form-select shadow-cst mt-1"
                        placeholder={filter.type === "tasks" ? "Search by Task or Evidence" : "Search by Job, Job Category or Evidence"}
                        onKeyUp={setSearchTxt}
                      />
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <Button variant="light" className="style1 w-100 radius-right shadow-cst h-100" onClick={() => setFilter(initFilter())}>
                    Clear
                  </Button>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
        <Row className="mt-4">
          <Col>
            <Card border="light" className="shadow table-section p-sm-0 p-lg-1">
              <Card.Body>
                {data.loading && (
                  <Alert variant="success" className="p-3">
                    <p className="loading-msg">Fetching evidences.. </p>
                    <ProgressBar variant="success" animated now={100} />
                  </Alert>
                )}
                {!data.loading && (
                  <>
                    <div className="d-flex flex-row-reverse">
                      {pageSelect()}
                      {showPagination(data)}
                    </div>
                    <Table striped hover responsive>
                      <thead>
                        <tr>
                          <th className="text-center">Sl #</th>
                          <th>{filter.type === "tasks" ? "Completed On" : "Job Date"}</th>
                          <th>{filter.type === "tasks" ? "Task" : "Job"}</th>
                          {filter.type !== "tasks" && <th>Job Category</th>}
                          <th>Username</th>
                          <th>Evidence</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.records.length === 0 && (
                          <tr>
                            <td colspan="6">
                              <Alert variant="danger" className="text-center p-5">
                                No evidences found!
                              </Alert>
                            </td>
                          </tr>
                        )}
                        {data.records.map((d, idx) => {
                          const evidences = filter.type === "tasks" ? [d.evidence] : JSON.parse(d.evidence);
                          return (
                            <tr key={d.id}>
                              <td>
                                <div className={`tb-lable tb-lable-success text-center`}>{Utils.addZero(getRecordStart(idx))}</div>
                              </td>
                              <td className="align-middle">{filter.type === "tasks" ? d.completed_on : d.job_date}</td>
                              <td className="align-middle" style={{ whiteSpace: "pre-wrap" }}>
                                {filter.type === "tasks" ? d.task_name : d.job_name.substring(1, d.job_name.length - 1)}
                              </td>
                              {filter.type !== "tasks" && <td className="align-middle">{d.cat_name}</td>}
                              <td className="align-middle">{d.uname}</td>
                              <td className="align-middle">
                                <Button
                                  onClick={() =>
                                    setShowEvidences({
                                      id: d.id,
                                      evidences: evidences,
                                    })
                                  }
                                >
                                  View ({evidences.length})
                                </Button>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </Table>
                    <div className="d-flex flex-row-reverse">
                      {pageSelect()}
                      {showPagination(data)}
                    </div>
                  </>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {_.get(showEvidences, "evidences", []).length > 0 && (
          <EvidenceList data={showEvidences} type={filter.type} onHide={() => setShowEvidences({})} />
        )}
      </div>
    </React.Fragment>
  );
};

export default Evidences;
